import { createSelector } from "reselect";

export const languagesSelector = createSelector(
    state => state.services.languages,
    state => state
);
